import celeste_5 from './5.jpg';

export {
    celeste_5
}


const celeste = {
    celeste_1: require('./1.jpg').default,
    celeste_2: require('./2.jpg').default,
    celeste_3: require('./3.jpg').default,
    celeste_4: require('./4.jpg').default,
    celeste_5: require('./5.jpg').default,
    celeste_6: require('./6.jpg').default,
}

export default celeste;